export default function CreatePage() {
  return (
    <div className="min-h-screen bg-[#F9FAFB] pb-28 text-[#2B3A67]" style={{ fontFamily: "'Outfit', sans-serif" }}>
      <section className="px-6 pt-6">
        <div className="relative overflow-hidden rounded-[32px] min-h-[260px] md:min-h-[320px] shadow-xl" data-testid="create-hero">
          <video
            className="absolute inset-0 h-full w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            data-testid="create-hero-video"
          >
            <source src="https://videos.pexels.com/video-files/3173312/3173312-hd_1280_720_25fps.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-r from-[#1F2A4A]/90 via-[#1F2A4A]/70 to-transparent" />
          <div className="relative z-10 p-6 md:p-8 text-white">
            <span
              className="inline-flex items-center rounded-full bg-white/15 px-4 py-1 text-xs uppercase tracking-[0.3em]"
              data-testid="create-status-badge"
            >
              In progress
            </span>
            <h1 data-testid="create-title" className="mt-4 text-3xl md:text-4xl font-extrabold">
              Create with Backyard
            </h1>
            <p data-testid="create-subtitle" className="mt-3 max-w-xl text-sm md:text-base text-white/80">
              A new platform for aspiring artists to collaborate with Backyard and spread the love through their talent.
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-6 py-8 space-y-6">
        <section className="grid gap-4 md:grid-cols-3" data-testid="create-pillars">
          {[
            {
              title: 'Collaborate with Backyard',
              text: 'Partner with our community and co-create events that move people.',
              id: 'collaborate',
            },
            {
              title: 'Share your story',
              text: 'Showcase your craft in experiences that celebrate creativity and culture.',
              id: 'story',
            },
            {
              title: 'Amplify your impact',
              text: 'Reach new audiences and keep the spirit of connection alive.',
              id: 'impact',
            },
          ].map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-3xl p-6 shadow-md border border-gray-100"
              data-testid={`create-pillar-${item.id}`}
            >
              <h3 className="text-lg font-bold" data-testid={`create-pillar-title-${item.id}`}>
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-gray-500" data-testid={`create-pillar-text-${item.id}`}>
                {item.text}
              </p>
            </div>
          ))}
        </section>

        <section className="bg-[#2B3A67] text-white rounded-[32px] p-6 md:p-8 shadow-xl" data-testid="create-open-call">
          <div className="flex items-center justify-between flex-wrap gap-3">
            <h2 className="text-xl font-semibold" data-testid="create-open-call-title">
              We’re building the first creator cohort
            </h2>
            <span
              className="rounded-full bg-white/15 px-4 py-1 text-xs uppercase tracking-[0.2em]"
              data-testid="create-open-call-pill"
            >
              Coming soon
            </span>
          </div>
          <p className="mt-4 text-sm text-white/80" data-testid="create-open-call-copy">
            The Create experience is being crafted with care. When applications open, you’ll get early access to collaborate, host, and inspire.
          </p>
          <a
            href="mailto:create@backyard.com"
            className="mt-5 inline-flex items-center justify-center rounded-full bg-white text-[#2B3A67] px-6 py-3 text-sm font-semibold"
            data-testid="create-notify-button"
          >
            Get notified
          </a>
        </section>

        <section className="grid gap-4 md:grid-cols-2" data-testid="create-how-it-works">
          {[
            {
              title: 'Apply once we open',
              text: 'Submit your vision, past work, and collaboration goals in a lightweight application.',
              id: 'apply',
            },
            {
              title: 'Co-create with Backyard',
              text: 'Work with our team to shape experiences that celebrate your talent and community.',
              id: 'cocreate',
            },
          ].map((item, index) => (
            <div
              key={item.id}
              className="bg-white rounded-3xl p-6 shadow-md border border-gray-100"
              data-testid={`create-step-${item.id}`}
            >
              <div className="text-xs font-semibold tracking-[0.3em] text-[#E54562]" data-testid={`create-step-index-${item.id}`}>
                0{index + 1}
              </div>
              <h3 className="mt-3 text-lg font-bold" data-testid={`create-step-title-${item.id}`}>
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-gray-500" data-testid={`create-step-text-${item.id}`}>
                {item.text}
              </p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}